import { Observable as O } from 'rxjs/Observable'
import 'rxjs/add/observable/empty'
import 'rxjs/add/observable/throw'
import 'rxjs/add/operator/catch'
import 'rxjs/add/operator/retry'
import 'rxjs/add/operator/switchMap'

export { O }
